import {combineReducers} from 'redux';

import details from './plan-subscription-bulk-create-select-details/reducer';
import general from './plan-subscription-bulk-create-general/reducer';
import selectOrgs from './plan-subscription-bulk-create-select-orgs/reducer';
import summary from './plan-subscription-bulk-create-summary/reducer';

export default combineReducers({general, details, selectOrgs, summary});
